import { render, staticRenderFns } from "./InterestNews.vue?vue&type=template&id=abd34d80&"
import script from "./InterestNews.vue?vue&type=script&lang=js&"
export * from "./InterestNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abd34d80')) {
      api.createRecord('abd34d80', component.options)
    } else {
      api.reload('abd34d80', component.options)
    }
    module.hot.accept("./InterestNews.vue?vue&type=template&id=abd34d80&", function () {
      api.rerender('abd34d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/interest-news/InterestNews.vue"
export default component.exports